<template>
  <section>
    <ImageAndTitleBlocks :items="data.category_urls"/>
  </section>
</template>

<style scoped>

</style>

<script>
import ImageAndTitleBlocks from "@/components/organisms/ImageAndTitleBlocks.vue";

export default {
  props: {
    data: Object
  },
  components: {ImageAndTitleBlocks}

}
</script>

<style scoped lang="scss">
section {
  @include mobile {
    margin-right: -16px;
  }
}
</style>
